const PortletConstants = {

	// Portlet mode

	EDIT: 'edit',
	HELP: 'help',
	VIEW: 'view',

	// Window state

	MAXIMIZED: 'maximized',
	MINIMIZED: 'minimized',
	NORMAL: 'normal',

	// Resource URL cacheability

	FULL: 'cacheLevelFull',
	PAGE: 'cacheLevelPage',
	PORTLET: 'cacheLevelPortlet'
};

export {PortletConstants};
export default PortletConstants;